export const Text = {
  baseStyle: {
    color: 'black.900',
    fontSize: { md: 'md', sm: 'sm' },
    _dark: {
      color: 'white',
    },
    a: {
      color: 'primary.normal',
    },
  },
  variants: {
    secondary: {
      color: 'gray.650',
      fontSize: { md: 'sm', sm: 'xs' },
    },
    warning: {
      color: 'black.900',
      fontSize: { md: 'md', sm: 'sm' },
      _dark: {
        color: 'white',
      },
      a: {
        color: 'primary.warning',
      },
    },
  },
}
